import React, { Component, Fragment } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Button, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import InformedConsentModal from "./InformedConsentModal";

class InformedConsent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openModalCreate: false,
      activeTab: "1",
    };
  }

  handleOpenModal = () => {
    this.setState({ openModalCreate: true });
  };

  handleCloseModal = () => {
    this.setState({ openModalCreate: false });
  };

  toggle = (tab) => {
    const { activeTab } = this.state;
    if (activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };

  autoIncrement = () => {
    let lastOneArray = this.props.data.consentimiento_informado.at(-1);

    if (lastOneArray === undefined) {
      return 1;
    }

    return lastOneArray.id + 1;
  };

  getLastContent = () => {
    let lastOneArray = this.props.data.consentimiento_informado.at(-1);
    if (lastOneArray === undefined) {
      return "";
    }

    return lastOneArray.contenido;
  };

  onSave = (titulo) => {
    let infoConsentimiento = {
      id: this.autoIncrement(),
      titulo,
      contenido: this.getLastContent(),
    };

    this.props.handlerInformedConsent({
      consentimiento_informado: [
        ...this.props.data.consentimiento_informado,
        infoConsentimiento,
      ],
    });
  };

  handleContent = (data, informedConsent) => {
    const newArray = this.props.data.consentimiento_informado.map((consent) => {
      if (consent.id === informedConsent.id) {
        return { ...consent, contenido: data };
      }

      return consent;
    });
    this.props.handlerInformedConsent({ consentimiento_informado: newArray });
  };

  render() {
    const { activeTab } = this.state;    
    return (
      <Fragment>
        <div
          className="card__title"
          style={{ display: "flex", flexDirection: "row" }}
        >
          <h5 className="bold-text">Consentimiento Informado</h5>

          <Button
            color="primary"
            size="sm"
            style={{ marginLeft: "50%" }}
            onClick={() => {
              this.handleOpenModal(true);
            }}
          >
            Crear
          </Button>
          <InformedConsentModal
            openModalCreate={this.state.openModalCreate}
            closeModal={() => this.handleCloseModal(false)}
            onSave={this.onSave}
          />
        </div>
        <br />
        <Nav tabs>
          {this.props.data.consentimiento_informado.map(
            (informedConsent, index) => (
              <NavItem key={index}>
                <NavLink
                  className={
                    activeTab === (index + 1).toString() ? "active" : ""
                  }
                  onClick={() => this.toggle((index + 1).toString())}
                >
                  {informedConsent.titulo}
                </NavLink>
              </NavItem>
            )
          )}
        </Nav>
        <TabContent activeTab={activeTab}>
          {this.props.data.consentimiento_informado.map(
            (informedConsent, index) => (
              <TabPane tabId={`${index + 1}`} key={index}>
                <div>
                  <span>Consentimiento Informado</span>
                  <br />
                  <div>
                    <p>
                      <b>Variables:</b>
                      Puede Utilizar las siguientes variables para ser
                      reemplazadas en el Texto de manera Automatica, para
                      utilziarlas, en la Plantilla debe escribir entre llaves la
                      variable que desea utilizar
                    </p>
                    <ul>
                      <li>
                        {"{paciente}:"} Paciente que es atendido en la Cita
                        Médica
                      </li>
                      <li>
                        {"{procedimiento}:"} Consulta o Procedimiento que se le
                        realiza al Paciente (Ejemplo, Gamagrafia, Consulta
                        General)
                      </li>
                      <li>
                        {"{tipo_identidad}:"} Tipo de Documento del Paciente
                      </li>
                      <li>
                        {"{identidad}:"} Tipo y Número de Documento del Paciente
                      </li>
                      <li>{"{empresa}:"} IPS o Empresa</li>
                      <li>
                        {"{profesional}:"} Profesional en salud encargado del
                        Procedimiento o Consulta
                      </li>
                      <li>{"{direccion}:"} Dirección de la IPS</li>
                    </ul>
                  </div>

                  <div style={{ margin: 10 }}>
                    <CKEditor
                      key={index}
                      style={{ width: "100%", height: "200px" }}
                      editor={ClassicEditor}
                      data={informedConsent.contenido}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        this.handleContent(data, informedConsent);
                      }}
                    />
                  </div>
                </div>
              </TabPane>
            )
          )}
        </TabContent>
      </Fragment>
    );
  }
}

export default InformedConsent;
